import script from "./ManageBrandCreateEditBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBrandCreateEditBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageBrandCreateEditBox.vue?vue&type=style&index=0&id=fec4eef0&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fec4eef0"]])

export default __exports__